import SignDocuments from './SignDocuments';

const Omni = {
  SignDocuments,
};

export default Omni;
